const GetUserData = () => {
  const data = localStorage.getItem('userData');

  if (data) {
      return JSON.parse(data);
  } else {
      return {
          UserId: "",
          UserCode: "",
          UserName: "",
          UserEmail: "",
          UserPassword: "",
          UserMobile: "",
          ProjectIds: "",
          ProjectName: "",
          UserRole: "",
          WarehouseCode: "",
          SourceOfBusiness: "",
          IsActive: "",
          IsLoggedIn: "",
          Designation: "",
          WorkLocation: "",
          OtpDateTime: "",
          LoginProvider: "",
          ProviderKey: "",
          PermissionList: "",
          PermissionAction: "",
          OTPCounter: "",
          IsWrongPasswordAttempt: "",
          ValidationKey: "",
          ResponseMessage: ""
      };
  }
};

export default GetUserData;
